(function () {
  var ADD_ON_HANDLES = [
    'apple-digital-master-adm',
    'vinyl-master'
  ];

  var REQUIRED_HANDLES = [
    'stereo-mastering',
    'stem-mastering-5-stems'
  ];

  var ERROR_MSGS = {
    'vinyl-master': 'The Vinyl Master Add-on requires a Stereo Mastering or Stem Mastering in your cart — in equal quantity.',
    'apple-digital-master-adm': 'The Apple Digital Master Add-on requires a Stereo Mastering or Stem Mastering in your cart — in equal quantity.'
  };

  function getProductHandle() {
    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return null;
    var match = canonical.href.match(/\/products\/([^?#]+)/);
    return match ? match[1] : null;
  }

  function isAddOnPage() {
    return ADD_ON_HANDLES.indexOf(getProductHandle()) !== -1;
  }

  function fetchCart(callback) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(callback);
  }

  function getRequiredQtyInCart(cartItems) {
    return cartItems.reduce(function (sum, item) {
      if (REQUIRED_HANDLES.indexOf(item.handle) !== -1) {
        return sum + item.quantity;
      }
      return sum;
    }, 0);
  }

  function getAddOnQtyInCart(cartItems) {
    return cartItems.reduce(function (sum, item) {
      if (ADD_ON_HANDLES.indexOf(item.handle) !== -1) {
        return sum + item.quantity;
      }
      return sum;
    }, 0);
  }

  function showError(form, handle) {
    var existing = form.querySelector('.addon-error-msg');
    if (existing) return;
    var msg = document.createElement('p');
    msg.className = 'addon-error-msg';
    msg.style.cssText = 'color: red; margin-top: 1rem; font-size: 1.4rem;';
    msg.textContent = ERROR_MSGS[handle] || 'This add-on requires a Stereo Mastering or Stem Mastering in your cart — in equal quantity.';
    var btn = form.querySelector('[type="submit"]');
    btn.parentNode.insertBefore(msg, btn.nextSibling);
  }

  function removeError(form) {
    var existing = form.querySelector('.addon-error-msg');
    if (existing) existing.remove();
  }

  function init() {
    if (!isAddOnPage()) return;

    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var qtyInput = form.querySelector('[name="quantity"]');
      var addingQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      var handle = getProductHandle();

      fetchCart(function (cart) {
        var requiredInCart = getRequiredQtyInCart(cart.items);
        var addOnsInCart = getAddOnQtyInCart(cart.items);
        var totalAddOns = addOnsInCart + addingQty;

        if (requiredInCart < totalAddOns) {
          removeError(form);
          showError(form, handle);
        } else {
          removeError(form);
          form.submit();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();